import { render, staticRenderFns } from "./entquotas.vue?vue&type=template&id=3ab2b67e&"
import script from "./entquotas.vue?vue&type=script&lang=js&"
export * from "./entquotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports